<template>
  <canvas
    ref="c"
    :width="size"
    :height="size"
    :style="{ verticalAlign: 'middle', width: displayWidth + 'px', height: displayHeight + 'px' }"
  ></canvas>
</template>

<script>
export default {
  props: {
    size: { type: Number, default: 40 },
    displayWidth: { type: Number, default: 18 },
    displayHeight: { type: Number, default: 22 },
    color: { type: String, default: '#D97706' }
  },
  mounted () {
    this.draw()
  },
  methods: {
    draw () {
      const c = this.$refs.c
      if (!c) return
      const ctx = c.getContext('2d')
      const s = this.size
      ctx.fillStyle = this.color
      ctx.beginPath()
      ctx.moveTo(s * 0.68, 0)
      ctx.lineTo(s * 0.18, s * 0.52)
      ctx.lineTo(s * 0.46, s * 0.52)
      ctx.lineTo(s * 0.32, s)
      ctx.lineTo(s * 0.82, s * 0.48)
      ctx.lineTo(s * 0.54, s * 0.48)
      ctx.closePath()
      ctx.fill()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LightningIcon.vue